module.exports = __webpack_public_path__ + "media/images/sample_project-4ffede02cc5cd96fb1d3d838cb9bc94a.jpg";